/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Type_And_UsageInputs */

const en_admin_resources_type_and_usage = /** @type {(inputs: Admin_Resources_Type_And_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type & Usage`)
};

const de_admin_resources_type_and_usage = /** @type {(inputs: Admin_Resources_Type_And_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art und Verwendung`)
};

const es_admin_resources_type_and_usage = /** @type {(inputs: Admin_Resources_Type_And_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo y uso`)
};

const fr_admin_resources_type_and_usage = /** @type {(inputs: Admin_Resources_Type_And_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type et utilisation`)
};

/** @type {(inputs: Admin_Resources_Type_And_UsageInputs) => LocalizedString} */
const it_admin_resources_type_and_usage = en_admin_resources_type_and_usage;

/** @type {(inputs: Admin_Resources_Type_And_UsageInputs) => LocalizedString} */
const pt_br2_admin_resources_type_and_usage = en_admin_resources_type_and_usage;

/** @type {(inputs: Admin_Resources_Type_And_UsageInputs) => LocalizedString} */
const pl_admin_resources_type_and_usage = en_admin_resources_type_and_usage;

/** @type {(inputs: Admin_Resources_Type_And_UsageInputs) => LocalizedString} */
const hu_admin_resources_type_and_usage = en_admin_resources_type_and_usage;

/** @type {(inputs: Admin_Resources_Type_And_UsageInputs) => LocalizedString} */
const ro_admin_resources_type_and_usage = en_admin_resources_type_and_usage;

/**
* | output |
* | --- |
* | "Type & Usage" |
*
* @param {Admin_Resources_Type_And_UsageInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_type_and_usage = /** @type {((inputs?: Admin_Resources_Type_And_UsageInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Type_And_UsageInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_type_and_usage(inputs)
	if (locale === "de") return de_admin_resources_type_and_usage(inputs)
	if (locale === "es") return es_admin_resources_type_and_usage(inputs)
	if (locale === "fr") return fr_admin_resources_type_and_usage(inputs)
	if (locale === "it") return it_admin_resources_type_and_usage(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_type_and_usage(inputs)
	if (locale === "pl") return pl_admin_resources_type_and_usage(inputs)
	if (locale === "hu") return hu_admin_resources_type_and_usage(inputs)
	return ro_admin_resources_type_and_usage(inputs)
});
export { admin_resources_type_and_usage as "admin.resources.type_and_usage" }